import {
  Directive,
  HostListener,
  inject,
  Input,
  TemplateRef,
  ViewContainerRef,
} from "@angular/core";
import { AuthService } from "../../../services/auth.service";

type RoleRequirement = string | string[];

@Directive({
  selector: "[appHasRole]",
  standalone: true,
})
export class HasRoleDirective {
  private readonly templateRef = inject(TemplateRef<any>);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly authService = inject(AuthService);

  private requiredRoles: string[] = [];
  private elseTemplateRef?: TemplateRef<any>;
  private isRendered = false;

  @Input() set appHasRole(roleRequirement: RoleRequirement) {
    this.requiredRoles = Array.isArray(roleRequirement)
      ? roleRequirement
      : [roleRequirement];
    this.updateView();
  }

  @Input() set appHasRoleElse(template: TemplateRef<any> | undefined) {
    this.elseTemplateRef = template ?? undefined;
    this.updateView();
  }

  @HostListener("window:storage", ["$event"])
  onStorageChange(event: StorageEvent) {
    if (!event.key || event.key === "current_user") {
      this.updateView();
    }
  }

  private userHasRequiredRole(): boolean {
    const userRoles = this.authService.getCurrentUserRoles();
    if (!this.requiredRoles.length) return true;
    return this.requiredRoles.some((requiredRole) =>
      userRoles.includes(requiredRole),
    );
  }

  private updateView() {
    const isAllowed = this.userHasRequiredRole();

    if (isAllowed && !this.isRendered) {
      this.viewContainerRef.clear();
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.isRendered = true;
    } else if (!isAllowed) {
      this.viewContainerRef.clear();
      if (this.elseTemplateRef) {
        this.viewContainerRef.createEmbeddedView(this.elseTemplateRef);
        this.isRendered = true;
      } else {
        this.isRendered = false;
      }
    }
  }
}
